import { render, staticRenderFns } from "./UserListInSendMess.vue?vue&type=template&id=2e41aabe&scoped=true"
import script from "./UserListInSendMess.vue?vue&type=script&lang=js"
export * from "./UserListInSendMess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e41aabe",
  null
  
)

export default component.exports